export const Paths = {
	Sensor: {
		Analysis: '/sensorAnalysis',
	},
	Settings: {
		PredictiveAnalytics: '/settings/PredictiveAnalytics',
	},
};
